// This file was automatically generated from render.rxRefillRequestForm.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.rxRefillRequestForm');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.rxRefillRequestForm.approval = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="inlineFormContainer"><form class="rx-refill-approval-form"><div class="overlayContainer"><div class="el8StandardFontSize el8Wrap">This dispense approved, plus an additional <span class="refillText"><div class="orderMedRefillsContainer refillWrap"><input name="authRefills" type="text" class="orderMedRefills" /></div>refills.</span></div><div class="el8TextareaWrap spacer"><input type="text" class="w100" name="note" maxlength="70" /></div><div class="el8DialogButtonContainer"><ul class="el8ButtonContainer"><li class="el8ButtonItem"><button type="button" class="el8button el8PrimaryButton ebs-btn ebs-btn-primary" name="approve">Approve Rx</button></li><li class="el8ButtonItem"><button type="button" class="el8button el8SecondaryButton ebs-btn ebs-btn-default" name="cancel">Cancel</button></li></ul><span class="tabcatcher" tabindex="0"></span></div></div></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.rxRefillRequestForm.denial = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="inlineFormContainer"><form class="rx-refill-denial-form"><div class="overlayContainer"><div class="el8TextareaWrap"><input name="note" type="text" class="w100" maxlength="70" /></div><div class="spacer"></div><div class="el8DialogButtonContainer"><ul class="el8ButtonContainer"><li class="el8ButtonItem"><button type="button" class="el8button el8PrimaryButton ebs-btn ebs-btn-primary" name="deny">Deny</button></li>', (! opt_data.isControlled) ? '<li class="el8ButtonItem"><button type="button" class="el8button el8PrimaryButton ebs-btn ebs-btn-primary" name="denyWithNewRx">Deny with New Rx</button></li>' : '', '<li class="el8ButtonItem"><button type="button" class="el8button el8SecondaryButton ebs-btn ebs-btn-default" name="cancel">Cancel</button></li></ul><span class="tabcatcher" tabindex="0"></span></div></div></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.rxRefillRequestForm.controlledRenewal = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="inlineFormContainer"><form class="rx-refill-renewal-form"><div class="overlayContainer"><p>Regulations require a new prescription for controlled substances.</p><div class="el8TextareaWrap"><input name="note" type="text" class="w100" maxlength="70" /></div><div class="spacer"></div><div class="el8DialogButtonContainer"><ul class="el8ButtonContainer"><li class="el8ButtonItem"><button type="button" class="el8button el8PrimaryButton ebs-btn ebs-btn-primary" name="controlledRenewal">Continue</button></li><li class="el8ButtonItem"><button type="button" class="el8button el8SecondaryButton ebs-btn ebs-btn-default" name="cancel">Cancel</button></li></ul><span class="tabcatcher" tabindex="0"></span></div></div></form></div>');
  if (!opt_sb) return output.toString();
};
